
angular.module('clientDashboardApp').directive('cmImagePreview', function($uibModal) {

  return {
    restrict: 'A',
    scope: {
      cmImagePreview: '='
    },
    link: function(scope, element) {
      element.on('click', () => {
        openPreview(scope.cmImagePreview)
      })
    }
  };

  function openPreview(imageSource) {
    return $uibModal.open({
      backdrop: true,
      template: require('./imagePreviewDirective.html'),
      controller: function($scope) {
        $scope.imageSource = imageSource;
      },
      windowClass: 'image-preview-modal'
    });
  }

});
